import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpStatusService } from '@app/services/http-status/http-status.service';
import { ErrorMessageUtilService } from '@app/services/error-message/error-message-util.service';
import { LocalUrls } from '@assets/contract-faxe/local-urls';
import { PasswordService } from '@app/services/password/password.service';
import { KeyValuepair } from '@app/components/shared/model/key-valuepair';
import { defined } from '@app/fremework/functions';
import { SelectedRaceService } from '@app/services/selected-race.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  private loadingCalls = 0;

  constructor(
    private errorMessageUtilService: ErrorMessageUtilService,
    private httpStatusService: HttpStatusService,
    private passwordService: PasswordService,
    private selectedRaceService: SelectedRaceService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this.changeStatus(true, request.method);
    //request = this.setToken(request, request.url.includes('ChatHub'));
    request = this.setToken(request, false);

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          console.log('we got an error', error);
          if (!error.url.endsWith(LocalUrls.deployment)) {
            console.log('get action for error', error);
            this.errorMessageUtilService.getAction(error);
          }
        }
        throw error;
      }),
      finalize(() => {
        this.changeStatus(false, request.method);
      })
    );
  }

  private setToken(request: HttpRequest<any>, isChatHub: boolean): HttpRequest<any> {
    const raceGuid =
      this.getRaceGuid(request) ?? this.selectedRaceService.selectedRaceGuid;
    const token = this.passwordService.getToken(raceGuid);

    if (defined(token)) {
      return this.setHeader(request, {
        key: 'Authorization',
        value: isChatHub ? token : `Bearer ${token}`,
      });
    } else {
      console.warn('no token defined is chat hub', isChatHub);
    }
    return request;
  }

  private getRaceGuid(request: HttpRequest<any>): string | undefined {
    const raceInUrl = request.url.match(/\/races\/([^/?#]+)/i)?.[1];
    if (raceInUrl) {
      try {
        return decodeURIComponent(raceInUrl);
      } catch {
        return raceInUrl;
      }
    }
    return request.body?.raceGuid;
  }

  private setHeader(request: HttpRequest<any>, keyValuePair: KeyValuepair<string, string>): HttpRequest<any> {
    return request.clone({ headers: request.headers.set(keyValuePair.key, keyValuePair.value) });
  }

  private changeStatus(loading: boolean, method: string): void {
    if (['POST', 'PUT', 'DELETE', 'PATCH', 'GET'].indexOf(method) > -1) {
      if (loading) {
        this.loadingCalls++;
      } else {
        this.loadingCalls--;
      }
      this.httpStatusService.loading = this.loadingCalls > 0;
    }
  }

}
